import { Controller, useFormContext } from 'react-hook-form';
import _ from 'lodash';
import CustomSelectInput from '../../CustomSelectInput/CustomSelectInput';
import { MultiSelectField } from '../types';

const MultiSelectFieldForm = ({ field }: { field: MultiSelectField }) => {
  const {
    control,
    formState: { errors },
    setValue,
    getValues,
  } = useFormContext();
  const currentError = _.get(errors, field.key);

  return (
    <div>
      <Controller
        name={field.key}
        control={control}
        render={({ field: renderField }) => (
          <CustomSelectInput
            label={field.label}
            options={field.options as any}
            value={renderField.value ?? []}
            isDisabled={field.disabled as boolean}
            placeholder={field.placeholder}
            isMulti={true}
            autoHeight={field.autoHeight ?? true}
            loadOptions={field.loadOptions as any}
            defaultOptions={field.defaultOptions}
            isOptionSelected={field.isOptionSelected}
            components={field.components}
            onChange={(val) => {
              renderField.onChange(val);
              field.onAfterChange?.(val, { setValue, getValues });
            }}
          />
        )}
      />
      {currentError && (
        <p className="text-danger" style={{ fontSize: 12 }}>
          {(currentError as any).message}
        </p>
      )}
    </div>
  );
};

export default MultiSelectFieldForm;
